import { setStatus } from '../status'
import { UPDATE_VERSION_MUTATION } from 'client/mutations'

export const SAVE_OBJECTS_STARTED = 'SAVE_OBJECTS_STARTED'
export const SAVE_OBJECTS_SUCCEEDED = 'SAVE_OBJECTS_SUCCEEDED'
export const SAVE_OBJECTS_FAILED = 'SAVE_OBJECTS_FAILED'

export const saveObjectsStarted = () => ({
  type: SAVE_OBJECTS_STARTED,
})

export const saveObjectsSucceeded = () => ({
  type: SAVE_OBJECTS_SUCCEEDED,
})

export const saveObjectsFailed = payload => ({
  type: SAVE_OBJECTS_FAILED,
  payload,
})

export const saveObjects =
  ({ versionId, saveLayers }) =>
  (dispatch, getState, client) => {
    dispatch(saveObjectsStarted())
    const { objects, cfd, layers, userInterface, loadingDock, install } = getState()
    const data = {
      units: objects.present.units,
      objects: objects.present.objects,
      products: objects.present.products,
      doors: objects.present.doors,
      utilityBoxes: objects.present.utilityBoxes,
      obstructions: objects.present.obstructions,
      comfortZones: objects.present.comfortZones,
      dimensions: objects.present.dimensions,
      segments: objects.present.segments,
      roofs: objects.present.roofs,
      roofSections: objects.present.roofSections,
      elevationPoints: objects.present.elevationPoints,
      elevationLines: objects.present.elevationLines,
      backgroundImage: objects.present.backgroundImage,
      ceilings: objects.present.ceilings,
      loadingDock,
      install,
      cfd: {
        isValid: cfd.isValid,
        validTypes: cfd.validTypes,
        metrics: cfd.metrics,
      },
      userInterface: {
        isTouchUI: userInterface.isTouchUI,
      },
    }

    if (saveLayers) {
      data.layers = layers
    }

    client
      .mutate({
        mutation: UPDATE_VERSION_MUTATION,
        variables: {
          id: versionId,
          data,
        },
      })
      .then(() => {
        dispatch(saveObjectsSucceeded())
      })
      .catch(error => {
        let statusText
        switch (error.message) {
          case 'Not Allowed!':
          case 'Must provide version data in updates':
          case 'Cannot find version for update':
          case 'Cannot find floor for version update':
          case 'Cannot find facility for version update': {
            statusText = error.message
            break
          }
          case 'Template Is Read Only': {
            statusText = 'You cannot save this template.'
            break
          }
          case 'Facility Is Read Only': {
            statusText = 'Facility owned by user outside your organization, make a copy to edit.'
            break
          }
          default: {
            statusText = 'Server error'
          }
        }

        dispatch(setStatus({ type: 'error', text: `Save failed: ${statusText}` }))
        dispatch(saveObjectsFailed(error))
      })
  }
